import React from 'react'
import Section, { SectionBody, SectionHeading } from '../../components/Section'
import BackToTop from '../../components/BackToTop'
import InstagramEmbed from '../../components/InstagramEmbed'

interface FourRunnerProps {
    theme: string
}

const FourRunner: React.FC<FourRunnerProps> = ({ theme }) => {
    const instagramPosts: string[] = [
        'https://www.instagram.com/p/ChPlEI2OYZA/',
        'https://www.instagram.com/p/C3gVT-jMKES/',
        'https://www.instagram.com/p/C74vKutugZF/',
        'https://www.instagram.com/p/CMyMoVIgbGp/',
        'https://www.instagram.com/p/CMfq59pgk79/',
        'https://www.instagram.com/p/CLFpyfFAzfH/',
        'https://www.instagram.com/p/CJ5LlDQA8vw/',
        'https://www.instagram.com/p/CJrSd2jAkN7/',
    ]

    return (
        <div>
            <Section id="4runner">
                <SectionHeading title="1996 Toyota 4Runner SR5" />
                <SectionBody>
                  

                    <div className="mt-8">
                        
                        <p className="text-gray-400 mb-4">
                            Follow along on <a href="https://www.instagram.com/4runnnnnnnnnner" target="_blank" rel="noopener noreferrer" className="text-lime-500 hover:text-lime-400 transition-colors">Instagram</a>
                        </p>
                        
                        {instagramPosts.length > 0 && (
                            <div className="space-y-6">
                                {instagramPosts.map((postUrl, index) => (
                                    <InstagramEmbed key={index} url={postUrl} />
                                ))}
                            </div>
                        )}
                    </div>
                </SectionBody>
            </Section>

            <BackToTop theme={theme} />
        </div>
    )
}

export default FourRunner

